import m from "mithril"
import { MithrilTsxComponent } from "mithril-tsx-component"
import { StoreItem } from "./item"
import { StoreSearch } from "./search"
import { ICoords, IStore } from "./utils"
import * as Api from "./api"

interface IChooseStore {
    isExpressService?: boolean
}

export class ChooseStore extends MithrilTsxComponent<IChooseStore> {
    stores: IStore[] = []
    geo: ICoords

    view(v: m.Vnode<IChooseStore>) {
        return <div>
            <StoreSearch
                onchange={r => this.stores = r}
                ongeo={c => this.geo = c}
            />
            {this.stores.length > 0 && <div className="store-overview">
                {this.stores.map(item =>
                    <StoreItem
                        key={item.id}
                        {...item}
                        isExpressService={v.attrs.isExpressService}
                        currentgeo={this.geo}
                        onselect={async () => {
                            if (!v.attrs.isExpressService)
                                await Api.updateStore(item.id)
                            else
                                location.href = item.navigationUrl
                        }}
                    />
                )}
            </div>
            }
        </div>
    }
}